import moment from 'moment';
import React, { useEffect } from 'react'
import { getCurrentFinancialYear } from '../../CommonMethhods/CommonMethods';

export default function IBADuration(props) {
    let setCustomShow = props.setCustomShow
    let setFromDate = props.setFromDate
    let setToDate = props.setToDate
    console.log("duration prop", props?.onChangeDuration);


    const onChangeDuration = (e) => {
        let val = e.target.value

        props.setSelectDuration(val);
        props.onChangeDuration && props.onChangeDuration(val);

        let date = new Date();
        let firstDay = "";
        let lastDay = "";

        console.log("val", val)

        if (val === "custom") {
            setCustomShow(true)
        }
        else if (val === "today") {
            setCustomShow(false);
            let todayDate = new Date();
            firstDay = moment(todayDate, "MM-DD-YYYY").format("MM-DD-YYYY");
            lastDay = moment(todayDate, "MM-DD-YYYY").format("MM-DD-YYYY");
        }
        else if (val === "yesterday") {
            setCustomShow(false);
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            firstDay = moment(yesterday, "MM-DD-YYYY").format("MM-DD-YYYY");
            lastDay = moment(yesterday, "MM-DD-YYYY").format("MM-DD-YYYY");
        }
        else if (val === "week") {
            setCustomShow(false);
            let startOfWeek = moment().startOf("week").add(1, "day");
            let endOfWeek = moment();
            firstDay = startOfWeek.format("MM-DD-YYYY");
            lastDay = endOfWeek.format("MM-DD-YYYY");
        }
        else if (val == "last_week") {
            setCustomShow(false);
            let startLastWeek = moment()
                .subtract(1, "week")
                .startOf("week")
                .add(1, "day");
            let endLastWeek = moment()
                .subtract(1, "week")
                .endOf("week")
                .add(1, "day");
            firstDay = startLastWeek.format("MM-DD-YYYY");
            lastDay = endLastWeek.format("MM-DD-YYYY");
        }

        else if (val === "till_date") {
            setCustomShow(false);
            let todayDate = new Date();
            firstDay = moment("2000-01-01").format("MM-DD-YYYY"); // backend accepted start
            lastDay = moment(todayDate, "MM-DD-YYYY").format("MM-DD-YYYY");
        }
        else if (val === "currentmnth") {

            setCustomShow(false)
            let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
            firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            let lastVal = new Date();
            lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            console.log("first", firstDay, firstVal)
        }
        else if (val === "lastmnth") {
            setCustomShow(false)
            let firstVal = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            let lastVal = new Date(date.getFullYear(), date.getMonth(), 0);
            lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        }
        else if (val === "currentyr") {
            setCustomShow(false)
            let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
            let firstVal = new Date(
                currentFyearStart.getFullYear(),
                currentFyearStart.getMonth(),
                1
            );
            firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            let lastVal = new Date();
            lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            console.log("current yr", firstDay, lastDay)
        }
        else if (val === "lastyr") {
            setCustomShow(false)
            let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
            let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
            let firstVal = new Date(
                currentFyearStart.getFullYear() - 1,
                currentFyearStart.getMonth(),
                1
            );
            firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            let lastVal = new Date(
                currentFyearEnd.getFullYear() - 1,
                currentFyearEnd.getMonth(),
                31
            );
            lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
            console.log("last yr", firstDay, lastDay)
        }
        else {
            setCustomShow(false)
            props.setSelectDuration("")
        }
        setFromDate(firstDay)
        setToDate(lastDay)

    }

    const onChangeDurationReport = (e) => {
    const val = e.target.value;
    props?.setSelectDuration(val);

    let firstDay = "";
    let lastDay = "";

    if (val === "today") {
    firstDay = moment().format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  } 
  else if (val === "yesterday") {
    firstDay = moment().subtract(1, "day").format("MM-DD-YYYY");
    lastDay = moment().subtract(1, "day").format("MM-DD-YYYY");
  } 
  else if (val === "this_week") {
    firstDay = moment()
      .startOf("week")
      .add(1, "day") // Monday
      .format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  } 
  else if (val === "last_week") {
    firstDay = moment()
      .subtract(1, "week")
      .startOf("week")
      .add(1, "day")
      .format("MM-DD-YYYY");
    lastDay = moment()
      .subtract(1, "week")
      .endOf("week")
      .add(1, "day")
      .format("MM-DD-YYYY");
  } 
  else if (val === "this_month") {
    firstDay = moment().startOf("month").format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  } 
  else if (val === "last_month") {
    firstDay = moment()
      .subtract(1, "month")
      .startOf("month")
      .format("MM-DD-YYYY");
    lastDay = moment()
      .subtract(1, "month")
      .endOf("month")
      .format("MM-DD-YYYY");
  } 
  else if (val === "till_date") {
    firstDay = moment("2000-01-01").format("MM-DD-YYYY");
    lastDay = moment().format("MM-DD-YYYY");
  }

    setFromDate(firstDay);
    setToDate(lastDay);
  };

    return (
        <>

            {props?.label === "iba-date" ?
                <div className='ov-drop'>
                    <select className='dropdown-iba' onChange={onChangeDuration}
                        value={props?.selectDuration}>

                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="week">This Week</option>
                        <option value="last_week">Last Week</option>
                        <option value="currentmnth">This Month</option>
                        <option value="lastmnth">Last Month</option>
                        <option value="currentyr">This Year</option>
                        <option value="lastyr">Last Year</option>
                        <option value="till_date">Till Date</option>
                        <option value="custom">Custom Date</option>
                    </select>
                </div>
                :

                <div className='ov-drop'>
                    <select className='dropdown-iba' onChange={onChangeDurationReport}
                        value={props?.selectDuration}>
                             <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="this_week">This Week</option>
                        <option value="last_week">Last Week</option>
                        <option value="this_month">This Month</option>
                        <option value="last_month">Last Month</option>
                        <option value="till_date">Till Date</option>
                        {/* <option value="last_7_days">Last 7 Days</option>
                        <option value="last_month">Last Month</option>
                        <option value="last_3_months">Last 3 Months</option>
                        <option value="last_6_months">Last 6 Months</option>
                        <option value="last_year">Last Year</option>
                        <option value="max">Max</option> */}
                    </select>
                </div>

            }
        </>
    )
}
